import { Box, Button } from "@mui/material";
import useDispatch from "hooks/useDispatch";
import { useSearchParams } from "react-router-dom";
import { checkOrder, getOpenOrderList } from "store/slices/trade/tradeSlice";

function OrderCancelButton({ item, onClick }) {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()

  const status = item?.stateId;

  const pageNumber = searchParams.get("page") || 1;
  const pageSize = searchParams.get("perPage") || 10;

  const onCheck = async () => {
    await dispatch(checkOrder({ orderId: item?.id }), 'Order check request has been sent')

    dispatch(
      getOpenOrderList({
        pageNumber: pageNumber,
        pageSize: pageSize,
      })
    );
  }

  if (status === 2 || status === 3) {
    return (
      <Box display="flex" alignItems="center" justifyContent={{ xs: "flex-start", md: 'flex-end' }}>
        <Button
          variant={"contained"}
          sx={{
            minWidth: "58px",
            fontSize: "14px !important",
            fontWeight: "600",
          }}
          onClick={() => onClick(item)}
          size="small"
          color="error"
        >
          Cancel
        </Button>

        <Button
          variant={"contained"}
          sx={{
            minWidth: "58px",
            fontSize: "14px !important",
            fontWeight: "600",
            ml: 1
          }}
          onClick={onCheck}
          size="small"
          color="info"
        >
          Check
        </Button>
      </Box>
    );
  }

  return "";
}

export default OrderCancelButton;
